import { render } from "./DynamicFormLink.vue?vue&type=template&id=ab03d500&ts=true"
import script from "./DynamicFormLink.vue?vue&type=script&lang=ts"
export * from "./DynamicFormLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__